import React from 'react';
import { Switch, Route, Redirect } from 'react-router';
import * as mapper from 'lib/mapper';
import RecordingContainer from 'containers/recording/RecordingContainer';

function Recording() {
  return (
    <>
      <Switch>
        <Route path={`${mapper.pageUrl.recording.index}`} component={RecordingContainer} />
        <Route component={() => <Redirect to={mapper.pageUrl.error.notFound} />} />
      </Switch>
    </>
  );
}

export default Recording;
